import { useMemo } from "react"
import useSchoolFilteredProgramsDB from "../components/curriculum/shared/useSchoolFilteredProgramsDB"
import useStockModulesDB from "../components/curriculum/shared/useStockModulesDB"

const toSearchTitle = (title) => {
  const baseTitle = String(title || "").trim()
  if (!baseTitle) {
    return ""
  }

  return baseTitle
}

export const useWorkReadinessSearchItems = ({
  firebase,
  subdomainSchoolId,
  subdomainAudienceType,
}) => {
  const {
    stockModules,
    isLoading: isModulesLoading,
    error: modulesError,
  } = useStockModulesDB(firebase, subdomainAudienceType, subdomainSchoolId)

  const {
    programListWithUserCompletion,
    areProgramsLoading,
    error: programsError,
  } = useSchoolFilteredProgramsDB(firebase, subdomainSchoolId, subdomainAudienceType)

  const moduleEntries = useMemo(() => {
    return (stockModules || [])
      .map((moduleItem) => ({
        id: `module-${moduleItem.id}`,
        title: toSearchTitle(moduleItem.title),
        path: `/modules/${moduleItem.id}`,
        work_readiness_type_text: "module",
        work_readiness_aliases_text: "module modules assignment assignments curriculum work readiness skills development",
      }))
      .filter((item) => Boolean(item.title))
  }, [stockModules])

  const programEntries = useMemo(() => {
    return (programListWithUserCompletion || [])
      .map((programItem) => ({
        id: `program-${programItem.id}`,
        title: toSearchTitle(programItem.title),
        path: `/programs/${programItem.id}`,
        work_readiness_type_text: "program",
        work_readiness_aliases_text: "program programs pathway pathways curriculum work readiness skills development",
      }))
      .filter((item) => Boolean(item.title))
  }, [programListWithUserCompletion])

  const items = useMemo(() => {
    return [...moduleEntries, ...programEntries].sort((a, b) => a.title.localeCompare(b.title))
  }, [moduleEntries, programEntries])

  const loading = isModulesLoading || areProgramsLoading
  const error = modulesError || programsError || null

  return {
    items,
    loading,
    error,
  }
}

export default useWorkReadinessSearchItems
